import { render, staticRenderFns } from "./history.card.vue?vue&type=template&id=46b7bb77&scoped=true&"
import script from "./history.card.vue?vue&type=script&lang=js&"
export * from "./history.card.vue?vue&type=script&lang=js&"
import style0 from "./history.card.vue?vue&type=style&index=0&id=46b7bb77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7bb77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
